import { gql } from '@apollo/client';

/**
 * MUTATION
 */
export const UPLOAD_VINYL_THEME = gql`
  mutation uploadVinylTheme($input: UploadVinylThemeInput!) {
    uploadVinylTheme(input: $input) {
      urls
    }
  }
`;

export const UPLOAD_VINYL_ASSET = gql`
  mutation uploadVinylAsset($input: UploadVinylAssetInput!) {
    uploadVinylAsset(input: $input) {
      url
    }
  }
`;

export const UPLOAD_VINYL_LEVEL_ICON = gql`
  mutation uploadVinylLevelIcon($input: UploadVinylLevelIconInput!) {
    uploadVinylLevelIcon(input: $input) {
      url
    }
  }
`;

/**
 * QUERIES
 */
export const GET_VINYL_STORED_ASSETS = gql`
  query vinylStoredAssets($itemId: ID!) {
    vinylStoredAssets(itemId: $itemId) {
      bucket
      bucketUrl
      files {
        name
        folder
        path
        url
        size
      }
    }
  }
`;
